<template>
  <div>
    <el-form :inline="true">
      <el-form-item>
        <el-button type="primary" @click="dialogVisible = true">新增</el-button>
      </el-form-item>
    </el-form>

    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      border
      stripe>

      <el-table-column
        prop="typeName"
        label="类型名称"
        width="160">
      </el-table-column>
      <el-table-column
        prop="laneType"
        label="类型编码"
        width="160">
      </el-table-column>
      <el-table-column
        prop="description"
        label="描述"
        width="400">
      </el-table-column>
      <el-table-column
        prop="delFlag"
        label="状态"
        width="100">
        <template slot-scope="scope">
          <el-tag size="small" v-if="scope.row.delFlag == 0" type="success">启用</el-tag>
          <el-tag size="small" v-else-if="scope.row.delFlag == 1" type="info">停用</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="icon"
        label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="editHandle(scope.row.id)">编辑</el-button>
          <el-divider direction="vertical"></el-divider>

          <template>
            <el-popconfirm title="这是一段内容确定删除吗？" @confirm="delHandle(scope.row.id, scope.row.delFlag)">
              <el-button type="text" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
          <el-divider direction="vertical"></el-divider>

          <el-button v-if="scope.row.delFlag == 1" type="text" @click="handleFlag(scope.row.id, 0)">启用</el-button>
          <el-button v-else type="text" @click="handleFlag(scope.row.id, 1)">停用</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--新增对话框-->
    <el-dialog
      :title="editForm.id == null ? '新增': '编辑'"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose">

      <el-form :model="editForm" :rules="editFormRules" ref="editForm" :label-width="'110px'">
        <el-form-item label="类型名称" prop="typeName">
          <el-input v-model="editForm.typeName" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="类型编码" prop="laneType">
          <el-input :disabled="editForm.id !== null && editForm.id !== '' ? true : false" v-model="editForm.laneType" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input type="textarea" :rows="3" v-model="editForm.description" style="width: 300px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm('editForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('editForm')">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  export default {
    name: "JourneyLaneType",
    data() {
      return {
        dialogVisible: false,
        tableData: [],
        editForm: {
          id: '',
          typeName: '',
          laneType: '',
          description: ''
        },
        editFormRules: {
          typeName: [{required: true, message: '请输入类型名称', trigger: 'blur'}],
          laneType: [{required: true, message: '请输入类型编码', trigger: 'blur'}]
        }
      }
    },
    created() {
      this.getJourneyLaneTypeList()
    },
    methods: {
      getJourneyLaneTypeList() {
        this.$axios.get("/uxm/journey-lane-type/list", {}).then(res => {
          if (res && res.data && res.data.data) {
            this.tableData = res.data.data || []
          } else {
            this.tableData = []
          }
        }).catch(error => {
          console.error('获取车道类型列表失败:', error)
          this.tableData = []
        })
      },
      handleFlag(id, state) {
        this.$confirm('是否确认进行此操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.post('/uxm/journey-lane-type/enableAndDisable/' + id +'/'+ state).then(res => {
            console.log('res',res)
            if (res.data.code == 200) {
              this.$message({
                showClose: true,
                message: '操作成功',
                type: 'success'
              });
              this.getJourneyLaneTypeList()
            } else {
              this.$message.error('操作失败');
            }
          })
        }).catch(() => {
        });
      },
      editHandle(id) {
        this.$axios.get('/uxm/journey-lane-type/info/' + id).then(res => {
          this.editForm = res.data.data
          this.dialogVisible = true
        })
      },
      delHandle(id, flag) {
        if (flag === false) {
          return this.$message.warning("正在启用的情况下不能删除，请停用再删除！");
        }
        this.$axios.post('/uxm/journey-lane-type/remove/'+ id).then(res => {
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success'
          });
          this.getJourneyLaneTypeList()
        })
      },
      handleClose() {
        this.resetForm('editForm')
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.dialogVisible = false
        this.editForm = { id: '' }
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$axios.post('/uxm/journey-lane-type/' + (this.editForm.id ? 'edit' : 'add'), this.editForm)
              .then(res => {
                this.$message({
                  showClose: true,
                  message: '恭喜你，操作成功',
                  type: 'success'
                });
                this.dialogVisible = false
                this.resetForm(formName)
                this.getJourneyLaneTypeList()
              })
          } else {
            return false;
          }
        });
      }
    }
  }
</script>

<style>

</style>
